import { BranchDetailsRoutPathOutput } from './branch-details-rout-path-output.model';
import { VehicleTypeRoutePathOutput } from './vehicle-type-route-path-output.model';
import { VehicleGroupRoutePathOutput } from './vehicle-group-route-path-output.model';
import { VehicleDetailsRoutPathOutput } from './vehicle-details-rout-path-output.model';
import { RoutePathRoutPathGroupOutput } from './route-path-rout-path-group-output.model';


export class RouteGroupWithOutStatusOutputData implements IRouteGroupWithOutStatusOutputData {
    /** The auto-generated id of the route group master */
    route_group_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The branch details type must be one of "All" or "Select" */
    branch_detail_type!: string;
    /** The vehicle  must be one of "Vehicle Type" or "Vehicle Group" */
    vehicle!: string;
    /** The vehicle type must be one of "All" or "Select" */
    vehicle_type!: string;
    /** The vehicle group must be one of "All" or "Select" */
    vehicle_group!: string;
    /** The vehicle number type must be one of "All" or "Select" */
    vehicle_number!: string;
    /** The route group name with 255 character limit */
    route_group_name!: string;
    route_group_branch_details!: BranchDetailsRoutPathOutput[];
    route_group_vehicle_type!: VehicleTypeRoutePathOutput[];
    route_group_vehicle_group!: VehicleGroupRoutePathOutput[];
    route_group_vehicle_details!: VehicleDetailsRoutPathOutput[];
    allocated_route!: RoutePathRoutPathGroupOutput[];
    status!: number;

    constructor(data?: IRouteGroupWithOutStatusOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route_group_id = _data["route_group_id"];
            this.company_details_id = _data["company_details_id"];
            this.branch_detail_type = _data["branch_detail_type"];
            this.vehicle = _data["vehicle"];
            this.vehicle_type = _data["vehicle_type"];
            this.vehicle_group = _data["vehicle_group"];
            this.vehicle_number = _data["vehicle_number"];
            this.route_group_name = _data["route_group_name"];
            if (Array.isArray(_data["route_group_branch_details"])) {
                this.route_group_branch_details = [] as any;
                for (let item of _data["route_group_branch_details"])
                    this.route_group_branch_details!.push(BranchDetailsRoutPathOutput.fromJS(item));
            }
            if (Array.isArray(_data["route_group_vehicle_type"])) {
                this.route_group_vehicle_type = [] as any;
                for (let item of _data["route_group_vehicle_type"])
                    this.route_group_vehicle_type!.push(VehicleTypeRoutePathOutput.fromJS(item));
            }
            if (Array.isArray(_data["route_group_vehicle_group"])) {
                this.route_group_vehicle_group = [] as any;
                for (let item of _data["route_group_vehicle_group"])
                    this.route_group_vehicle_group!.push(VehicleGroupRoutePathOutput.fromJS(item));
            }
            if (Array.isArray(_data["route_group_vehicle_details"])) {
                this.route_group_vehicle_details = [] as any;
                for (let item of _data["route_group_vehicle_details"])
                    this.route_group_vehicle_details!.push(VehicleDetailsRoutPathOutput.fromJS(item));
            }
            if (Array.isArray(_data["allocated_route"])) {
                this.allocated_route = [] as any;
                for (let item of _data["allocated_route"])
                    this.allocated_route!.push(RoutePathRoutPathGroupOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RouteGroupWithOutStatusOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new RouteGroupWithOutStatusOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route_group_id"] = this.route_group_id;
        data["company_details_id"] = this.company_details_id;
        data["branch_detail_type"] = this.branch_detail_type;
        data["vehicle"] = this.vehicle;
        data["vehicle_type"] = this.vehicle_type;
        data["vehicle_group"] = this.vehicle_group;
        data["vehicle_number"] = this.vehicle_number;
        data["route_group_name"] = this.route_group_name;
        if (Array.isArray(this.route_group_branch_details)) {
            data["route_group_branch_details"] = [];
            for (let item of this.route_group_branch_details)
                data["route_group_branch_details"].push(item.toJSON());
        }
        if (Array.isArray(this.route_group_vehicle_type)) {
            data["route_group_vehicle_type"] = [];
            for (let item of this.route_group_vehicle_type)
                data["route_group_vehicle_type"].push(item.toJSON());
        }
        if (Array.isArray(this.route_group_vehicle_group)) {
            data["route_group_vehicle_group"] = [];
            for (let item of this.route_group_vehicle_group)
                data["route_group_vehicle_group"].push(item.toJSON());
        }
        if (Array.isArray(this.route_group_vehicle_details)) {
            data["route_group_vehicle_details"] = [];
            for (let item of this.route_group_vehicle_details)
                data["route_group_vehicle_details"].push(item.toJSON());
        }
        if (Array.isArray(this.allocated_route)) {
            data["allocated_route"] = [];
            for (let item of this.allocated_route)
                data["allocated_route"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IRouteGroupWithOutStatusOutputData {
    /** The auto-generated id of the route group master */
    route_group_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The branch details type must be one of "All" or "Select" */
    branch_detail_type: string;
    /** The vehicle  must be one of "Vehicle Type" or "Vehicle Group" */
    vehicle: string;
    /** The vehicle type must be one of "All" or "Select" */
    vehicle_type: string;
    /** The vehicle group must be one of "All" or "Select" */
    vehicle_group: string;
    /** The vehicle number type must be one of "All" or "Select" */
    vehicle_number: string;
    /** The route group name with 255 character limit */
    route_group_name: string;
    route_group_branch_details: BranchDetailsRoutPathOutput[];
    route_group_vehicle_type: VehicleTypeRoutePathOutput[];
    route_group_vehicle_group: VehicleGroupRoutePathOutput[];
    route_group_vehicle_details: VehicleDetailsRoutPathOutput[];
    allocated_route: RoutePathRoutPathGroupOutput[];
    status: number;
}

